import API from "@/api/lib/api";

export const getAllMenu = async () => {
  try {
    const response = await API.get(`restaurant/menu-items`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getAllFlatMenu = async (restaurant_id) => {
  try {
    const response = await API.get(
      `restaurant/${restaurant_id}/all-menu-items-flat`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleMenu = async (menu_id) => {
  try {
    const response = await API.get(`restaurant/menu-items/${menu_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createMenu = async (data) => {
  try {
    const response = await API.post(`restaurant/menu-items`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateMenu = async (menu_id, data) => {
  try {
    const response = await API.put(`restaurant/menu-items/${menu_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteMenu = async (menu_id) => {
  try {
    const response = await API.delete(`restaurant/menu-items/${menu_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getMenuManagementOverview = async (restaurant_id) => {
  try {
    const response = await API.get(
      `restaurant/${restaurant_id}/menu-management-overview`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
